import { App } from '../../App.js'
import CONST_SOCKET from '../../const/socket'

import {
  createNewPostbackNode
} from '../../functions/utils'

// eslint-disable-next-line
export default async (component, event, ui) => {
  App.editor.view.area.pointermove(event)
  const { x, y } = App.editor.view.area.mouse

  const otnSingleNode = await component.createNode()
  otnSingleNode.position = [x, y]

  App.editor.addNode(otnSingleNode)
  
  const newPostbackNode = await createNewPostbackNode()
  newPostbackNode.position = [x + 250, y]

  App.editor.addNode(newPostbackNode)

  App.editor.connect(
    otnSingleNode.outputs.get(CONST_SOCKET.OTN_SINGLE_OUTPUT),
    newPostbackNode.inputs.get(CONST_SOCKET.NEW_POSTBACK_INPUT)
  )
}